// Typography.tsx
import styled from 'styled-components';

import {sharedBodyStyle, sharedStyle} from './sharedStyles';
import TextProps from './TextProps';
import {ExtendedDivProps, ExtendedHeadingProps, ExtendedParagraphProps} from './types';

// Filter out boolean props from TextProps to prevent them from being passed to DOM
const shouldForwardProp = (prop: string) => {
  const textPropsKeys: (keyof TextProps)[] = [
    'inline', 'newlines', 'left', 'right', 'black', 'grey', 'red', 
    'blue', 'green', 'darkGrey', 'brightGrey', 'white', 'full'
  ];
  return !textPropsKeys.includes(prop as keyof TextProps);
};

export const Digits = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedDivProps>`
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0;
  margin: 0;
  ${sharedStyle}
`;

export const Title1 = styled.h1.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  font-size: 26px;
  font-weight: bold;
  margin: 0;
  ${sharedStyle}
`;

export const Title2 = styled.h2.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  font-size: 20px;
  line-height: 20px;
  font-weight: bold;
  margin: 0;

  @media (min-width: 300px) {
    font-size: 12px;
  }
  @media (min-width: 750px) {
    font-size: 14px;
  }
  @media (min-width: 900px) {
    font-size: 18px;
  }
  @media (min-width: 1000px) {
    font-size: 20px;
  }

  ${sharedStyle}
`;

export const DigitsSmall = styled.p.withConfig({
  shouldForwardProp,
})<ExtendedParagraphProps>`
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  margin: 0;
  ${sharedStyle}
`;

export const CalendarHeaderDateContainer = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CalendarHeaderArrowButton = styled.button.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  height: 100%;
  border: none;
  outline: none;
  background: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  cursor: pointer;

  &:first-of-type img {
    transform: rotate(90deg);
  }

  &:last-of-type img {
    transform: rotate(270deg);
  }
`;
/**
 * Типовой заголовок хедера в системе.
 * @TODO вынести в какие-нибудь общие конфиги для styled components, сейчас он не на своем месте
 * @TODO ВАЖНО!!! Для заголовков будущих разделов используем именно этот компонент
 */
export const Title3 = styled.h3.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  margin: 0;
  
  min-width: 7em;
  
  &.settings__container-title {
    min-width: 12em;
  }
  
  @media(min-width: 350px) {
    font-size: 9px;
  }
  @media (min-width: 750px) {
    font-size: 9px;
  }
  @media (min-width: 900px) {
    font-size: 12px;
  }
  @media (min-width: 1000px) {
    font-size: 15px;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  ${sharedStyle}
`;

export const BidsRow = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 100%;
  
  button,
  button.transparent {
    margin: 0;
    height: 100%;
  }
  
  > div {
    width: 200px;
    margin: 0;
  }
`;

export const HeaderSearchButton = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  cursor: pointer;
  display: flex
;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 2em;
`;

export const BidsButton = styled.button.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  
`;

export const Title4 = styled.h4.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  margin: 0;
  ${sharedStyle}
`;

export const CommonText = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  margin: 0;
  ${sharedStyle}
`;

export const Body = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedDivProps>`
  text-align: start;
  ${sharedStyle}
  ${sharedBodyStyle}
  
  &.avatar__header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
  }
`;

export const CalendarHeaderDate = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedHeadingProps>`
  min-width: 13em; // обработка переполнения контейнера с датой, чтобы кнопки не скакали
  text-align: center;

  ${sharedStyle}
  ${sharedBodyStyle}
`;

export const BodyBold = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedDivProps>`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  text-align: left;
  ${sharedStyle}
`;

export const Link = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedDivProps>``;

export const Caption = styled.div.withConfig({
  shouldForwardProp,
})<ExtendedDivProps>`
  font-size: 12px;
  ${sharedStyle}
`;
